/* Change header market links */
(function(){
  function rewriteLinksIn(container, anchorSelector){
    if(!container) return;
    var links = container.querySelectorAll(anchorSelector);
    if(!links.length) return;
    var p = window.location.pathname, s = window.location.search, h = window.location.hash;
    links.forEach(function(a){
      try{
        var u = new URL(a.getAttribute('href'), a.baseURI || window.location.origin);
        u.pathname = p; u.search = s; u.hash = h;
        a.setAttribute('href', u.toString());
      }catch(_){}
    });
  }

  function updateDropdown(comp){
    if(!comp) return;
    rewriteLinksIn(comp.querySelector('#dropdown-country-'), 'a.localization-item');
    if(comp.shadowRoot) rewriteLinksIn(comp.shadowRoot.querySelector('#dropdown-country-'), 'a.localization-item');
  }

  function updateDrawer(comp){
    if(!comp) return;
    rewriteLinksIn(comp, '.menu-drawer__menu a[href]');
  }

  function updateAll(){
    document.querySelectorAll('dropdown-localization-component').forEach(updateDropdown);
    document.querySelectorAll('drawer-localization-component').forEach(updateDrawer);
  }

  var t;
  function debounceUpdate(){ clearTimeout(t); t = setTimeout(updateAll, 50); }

  function wireComponentObservers(){
    document.querySelectorAll('dropdown-localization-component').forEach(function(comp){
      if(comp.__wired) return; comp.__wired = true;
      var mo = new MutationObserver(debounceUpdate);
      mo.observe(comp, {subtree:true,childList:true,attributes:true,attributeFilter:['aria-expanded','hidden','open']});
      comp.addEventListener('click', debounceUpdate, true);
    });
    document.querySelectorAll('drawer-localization-component').forEach(function(comp){
      if(comp.__wired) return; comp.__wired = true;
      var mo = new MutationObserver(debounceUpdate);
      mo.observe(comp, {subtree:true,childList:true,attributes:true,attributeFilter:['open','hidden','aria-expanded']});
      comp.addEventListener('toggle', debounceUpdate, true);
      comp.addEventListener('click', debounceUpdate, true);
    });
  }

  function init(){
    updateAll();
    wireComponentObservers();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function(){ init(); });
  document.addEventListener('shopify:section:reorder', function(){ init(); });

  new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){
      var n = muts[i].target;
      if(n && (n.closest && (n.closest('dropdown-localization-component') || n.closest('drawer-localization-component')))){
        debounceUpdate();
        wireComponentObservers();
        break;
      }
    }
  }).observe(document.documentElement,{subtree:true,childList:true});
})();

/* Collection page: fake sale price, no badge */
(() => {
  const HANDLE = "training-program-yearly";
  const NEW_AMOUNT = "69.99";

  const card = document.querySelector(`product-card[data-product-handle="${HANDLE}"]`);
  if (!card) return;

  const patch = () => {
    const containers = card.querySelectorAll('div[ref="priceContainer"]');
    containers.forEach((container) => {
      if (container.dataset.salePatched === "1") return;

      const priceNode = container.querySelector('.price .money, .price');
      if (!priceNode) return;
      const text = (priceNode.textContent || "").trim();
      if (!text) return;

      const m = text.match(/^(\D*)([\d.,]+)(\D*)$/);
      const prefix = m ? m[1] : "";
      const suffix = m ? m[3] : "";

      const saleGroup = document.createElement('span');
      saleGroup.setAttribute('role', 'group');
      saleGroup.innerHTML = `<span class="price"><span class="money">${prefix}${NEW_AMOUNT}${suffix}</span></span>`;

      const compareGroup = document.createElement('span');
      compareGroup.setAttribute('role', 'group');
      compareGroup.innerHTML = `<span class="compare-at-price"><span class="money">${text}</span></span>`;

      container.innerHTML = "";
      container.appendChild(saleGroup);
      container.appendChild(compareGroup);
      container.dataset.salePatched = "1";
    });
  };

  let tries = 0;
  const tick = () => {
    patch();
    tries += 1;
    if (tries < 40) requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);

  const mo = new MutationObserver(() => patch());
  mo.observe(card, { childList: true, subtree: true });
})();

/* Product page: fake sale price (GBP 64.68) and add badge 
(() => {
  const NEW_AMOUNT = "69.99";
  if (!document.body.classList.contains("product-training-program-yearly")) return;

  const toNumber = (s) => {
    let v = (s || "").replace(/[^\d.,]/g, "");
    if (v.includes(",") && v.includes(".")) v = v.replace(/,/g, "");
    else if (v.includes(",") && !v.includes(".")) v = v.replace(",", ".");
    return parseFloat(v);
  };

  const container = document.querySelector('div[ref="priceContainer"]');
  if (!container) return;

  const priceNode = container.querySelector('.price .money, .price');
  if (!priceNode) return;

  const originalText = priceNode.textContent.trim();
  const m = originalText.match(/^(\D*)([\d.,]+)(\D*)$/);
  const prefix = m ? m[1] : "";
  const suffix = m ? m[3] : "";

  let compareMoney = container.querySelector('.compare-at-price > .money, .compare-at-price');
  const hasCompare = !!compareMoney;

  if (!hasCompare) {
    const saleGroup = document.createElement('span');
    saleGroup.setAttribute('role', 'group');
    saleGroup.innerHTML = `<span class="price"><span class="money">${prefix}${NEW_AMOUNT}${suffix}</span></span>`;

    const compareGroup = document.createElement('span');
    compareGroup.setAttribute('role', 'group');
    compareGroup.innerHTML = `<span class="compare-at-price"><span class="money">${originalText}</span></span>`;

    const origNum = toNumber(originalText);
    const newNum = toNumber(NEW_AMOUNT);
    if (isFinite(origNum) && origNum > 0 && isFinite(newNum) && newNum < origNum) {
      const badge = document.createElement('span');
      badge.className = 'sale-badge';
      badge.textContent = `-${Math.round(((origNum - newNum) / origNum) * 100)}%`;
      compareGroup.appendChild(badge);
    }

    container.innerHTML = "";
    container.appendChild(saleGroup);
    container.appendChild(compareGroup);
  } else {
    const priceNum = toNumber(priceNode.textContent);
    const compareNum = toNumber(compareMoney.textContent || compareMoney.innerText || "");
    let group = (compareMoney.nodeType === 1 ? compareMoney : container.querySelector('.compare-at-price')).closest('[role="group"]') || container;
    if (!group.querySelector('.sale-badge') && isFinite(compareNum) && compareNum > 0 && isFinite(priceNum) && priceNum < compareNum) {
      const badge = document.createElement('span');
      badge.className = 'sale-badge';
      badge.textContent = `-${Math.round(((compareNum - priceNum) / compareNum) * 100)}%`;
      group.appendChild(badge);
    }
  }
})();
*/

/* Move product page elements on mobile */
(function () {
  const mq = window.matchMedia('(max-width: 749px)');
  const priceEl = document.querySelector('product-price');
  const mediaEl = document.querySelector('.product-information__media');
  const uspsEl = document.querySelector('.product-usps-wrapper');
  if (!priceEl || !mediaEl || !uspsEl) return;

  [mediaEl, uspsEl].forEach(el => {
    if (!el.__originalParent) {
      el.__originalParent = el.parentNode;
      el.__originalNext = el.nextSibling;
    }
  });

  function run() {
    if (mq.matches) {
      priceEl.insertAdjacentElement('afterend', mediaEl);
      mediaEl.classList.add('show');

      mediaEl.insertAdjacentElement('afterend', uspsEl);
      uspsEl.classList.add('show');
    } else {
      [mediaEl, uspsEl].forEach(el => {
        const p = el.__originalParent;
        const n = el.__originalNext;
        if (p) {
          if (n && n.parentNode === p) {
            p.insertBefore(el, n);
          } else {
            p.appendChild(el);
          }
        }
        el.classList.remove('show');
      });
    }
  }

  run();
  mq.addEventListener('change', run);
  document.addEventListener('shopify:section:load', run);
  document.addEventListener('shopify:section:select', run);
})();

/* Add delivery date in product page */
const target = document.querySelector('.order-before-block p strong');

if (target) {
  const today = new Date();
  today.setDate(today.getDate() + 3);

  const dd = String(today.getDate()).padStart(2, '0');
  const mm = String(today.getMonth() + 1).padStart(2, '0');
  const yyyy = today.getFullYear();

  const formattedDate = `${dd}/${mm}/${yyyy}`;

  target.textContent = formattedDate;
}

/* Add people viewing in product page */
const pulsator = document.querySelector('.pulsator p strong');

if (pulsator) {
  const randomNumber = Math.floor(Math.random() * (100 - 50 + 1)) + 50;
  pulsator.textContent = randomNumber;
}

/* Move upsells add to cart button on mobile */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function ensureFooter(item) {
    var footer = item.querySelector('.fpro-upsell-mobile-cta');
    if (!footer) {
      footer = document.createElement('div');
      footer.className = 'fpro-upsell-mobile-cta';
      item.appendChild(footer);
    }
    return footer;
  }

  function makeProxyButton(originalBtn) {
    var proxy = document.createElement('button');
    proxy.type = 'button';
    proxy.className = originalBtn.className + ' fpro-upsells-proxy-atc';
    proxy.innerHTML = originalBtn.innerHTML;
    proxy.addEventListener('click', function () { originalBtn.click(); });
    var sync = function () {
      proxy.disabled = originalBtn.disabled;
      if (originalBtn.classList.contains('atc-added')) proxy.classList.add('atc-added'); else proxy.classList.remove('atc-added');
    };
    var mo = new MutationObserver(sync);
    mo.observe(originalBtn, { attributes: true, attributeFilter: ['disabled', 'class'] });
    sync();
    proxy._mo = mo;
    return proxy;
  }

  function apply() {
    document.querySelectorAll('.fpro-upsells-block__item').forEach(function (item) {
      var form = item.querySelector('.fpro-upsells-block__form');
      var atcComp = form ? form.querySelector('add-to-cart-component') : null;
      var originalBtn = atcComp ? (atcComp.querySelector('[ref="addToCartButton"]') || atcComp.querySelector('button[type="submit"]')) : null;
      if (!form || !atcComp || !originalBtn) return;

      if (mq.matches) {
        atcComp.classList.add('is-hidden-on-mobile');
        var footer = ensureFooter(item);
        var existing = footer.querySelector('.fpro-upsells-proxy-atc');
        if (!existing) {
          var proxy = makeProxyButton(originalBtn);
          footer.appendChild(proxy);
        }
      } else {
        atcComp.classList.remove('is-hidden-on-mobile');
        var footer = item.querySelector('.fpro-upsell-mobile-cta');
        if (footer) {
          var proxy = footer.querySelector('.fpro-upsells-proxy-atc');
          if (proxy) {
            if (proxy._mo) proxy._mo.disconnect();
            proxy.remove();
          }
        }
      }
    });
  }

  (mq.addEventListener ? mq.addEventListener('change', apply) : mq.addListener(apply));
  if (document.readyState !== 'loading') apply();
  else document.addEventListener('DOMContentLoaded', apply);
  document.addEventListener('shopify:section:load', apply);
})();

/* Order tracking and returns */
const fproTrackingNumber = document.querySelector('.tracking-labels .tracking-number');
const fproZipCode = document.querySelector('.tracking-labels .zip-code');

if (fproTrackingNumber || fproZipCode) {
  const fproObserver = new MutationObserver(() => {
    const fproFirstInputPage = document.querySelector('#trackingPageDiv .inputElement:first-child');
    const fproSecondInputPage = document.querySelector('#trackingPageDiv .inputElement:nth-child(3)');
    const fproFirstInputHeader = document.querySelector('#returnFormHeader .inputElement:first-child');

    if (fproFirstInputPage && fproTrackingNumber) {
      fproFirstInputPage.parentNode.insertBefore(fproTrackingNumber, fproFirstInputPage);
    }

    if (fproSecondInputPage && fproZipCode) {
      fproSecondInputPage.parentNode.insertBefore(fproZipCode, fproSecondInputPage);
    }

    if (fproFirstInputHeader && fproTrackingNumber) {
      const fproClone = fproTrackingNumber.cloneNode(true);
      fproFirstInputHeader.parentNode.insertBefore(fproClone, fproFirstInputHeader);
    }

    if (
      (fproFirstInputPage && fproTrackingNumber) &&
      (fproSecondInputPage && fproZipCode) &&
      (fproFirstInputHeader)
    ) {
      fproObserver.disconnect();
    }
  });

  fproObserver.observe(document.body, { childList: true, subtree: true });
}

/* Cart upsells carousel */
(function(){
  // Prevent duplicate registration if theme re-includes this file
  if (window.__upsellSwiperInit) return; 
  window.__upsellSwiperInit = true;

  var ROOT='[data-fpro-ecupsells]';

  function haveSwiper(){ return !!window.Swiper; }

  // Wait until viewport is measurable (>0px width)
  function whenMeasurable(el, cb){
    var start = performance.now();
    (function tick(){
      var r = el && el.getClientRects && el.getClientRects()[0];
      if (r && r.width > 0) { cb(); return; }
      if (performance.now() - start > 2000) { cb(); return; } // 2s cap
      requestAnimationFrame(tick);
    })();
  }

  function rebindNavigation(root, inst){
    if(!inst) return;
    var prev=root.querySelector('.fpro-ecupsells__btn--prev');
    var next=root.querySelector('.fpro-ecupsells__btn--next');
    try{
      if(inst.navigation && inst.navigation.destroy) inst.navigation.destroy();
      inst.params.navigation = inst.params.navigation || {};
      inst.params.navigation.prevEl = prev;
      inst.params.navigation.nextEl = next;
      if(inst.navigation && inst.navigation.init){ inst.navigation.init(); inst.navigation.update(); }
    }catch(_){}
    [ [prev,'prev'], [next,'next'] ].forEach(function(pair){
      var btn=pair[0], dir=pair[1];
      if(!btn || btn.__boundNavFallback) return;
      btn.__boundNavFallback = true;
      if(!btn.getAttribute('type')) btn.setAttribute('type','button');
      btn.addEventListener('click', function(e){
        try{
          if(root.__upsellsSwiper){
            e.preventDefault(); e.stopPropagation();
            dir==='prev' ? root.__upsellsSwiper.slidePrev() : root.__upsellsSwiper.slideNext();
          }
        }catch(_){}
      }, true);
    });
  }

  // Detect if Horizon swapped the inner swiper DOM
  function needsRebuild(inst, vp){
    if(!inst || !vp) return true;
    if(inst.el !== vp) return true;
    var currentWrapper = vp.querySelector('.swiper-wrapper');
    if(inst.wrapperEl && currentWrapper && inst.wrapperEl !== currentWrapper) return true;
    if(inst.wrapperEl && !vp.contains(inst.wrapperEl)) return true;
    return false;
  }

  function createInstance(root, vp){
    whenMeasurable(vp, function(){
      var inst = new Swiper(vp, {
        slidesPerView: 1,
        spaceBetween: 0,
        rewind: true,
        navigation: {
          prevEl: root.querySelector('.fpro-ecupsells__btn--prev'),
          nextEl: root.querySelector('.fpro-ecupsells__btn--next')
        },
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        watchOverflow: true
      });
      root.__upsellsSwiper = inst;

      // settle measurements
      requestAnimationFrame(function(){ try{ inst.update(); }catch(_){} });
      root.querySelectorAll('img[loading="lazy"]').forEach(function(img){
        img.addEventListener('load', function(){ try{ inst.update(); }catch(_){} }, { once:true });
      });

      rebindNavigation(root, inst);
    });
  }

  function initOne(root){
    if(!root) return;
    var vp=root.querySelector('.fpro-ecupsells__viewport');
    if(!vp) return;

    var inst = root.__upsellsSwiper;

    // If DOM got swapped (e.g., after removal to empty), rebuild
    if (inst && needsRebuild(inst, vp)){
      try{ inst.destroy(true,true); }catch(_){}
      root.__upsellsSwiper = null;
      if(!haveSwiper()) return;
      createInstance(root, vp);
      return;
    }

    // Otherwise update existing instance
    if (inst && typeof inst.update === 'function'){
      whenMeasurable(vp, function(){
        try{ inst.update(); }catch(_){}
        rebindNavigation(root, inst);
      });
      return;
    }

    // Create for the first time
    if(!haveSwiper()) return;
    createInstance(root, vp);
  }

  function initAll(scope){
    (scope||document).querySelectorAll(ROOT).forEach(initOne);
  }

  // Debounce
  var raf=null;
  function schedule(scope){
    if(raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function(){ initAll(scope||document); });
  }

  // Wait for Swiper global if loaded later
  function waitForSwiper(scope){
    if(haveSwiper()){ schedule(scope||document); return; }
    var tries=0, i=setInterval(function(){
      if(haveSwiper()){ clearInterval(i); schedule(scope||document); }
      else if(++tries>120){ clearInterval(i); }
    },50);
  }

  // Run now / DOM ready
  if(document.readyState!=='loading') waitForSwiper(document);
  else document.addEventListener('DOMContentLoaded', function(){ waitForSwiper(document); });

  // Listen globally (these events still fire even after section HTML is replaced)
  [
    'shopify:section:load',
    'cart:sections:replaced',
    'cart:updated',
    'line-item:removed',
    'cart:cleared',
    'cart-drawer:open'
  ].forEach(function(evt){
    document.addEventListener(evt, function(){ waitForSwiper(document); });
  });

  // Horizon drawer mutations & animation end
  function attachDrawerObservers(){
    var dialog = document.querySelector('cart-drawer-component dialog[ref="dialog"], cart-drawer-component dialog');
    if(!dialog) return;
    if(dialog.__upsellMoAttached) return;
    dialog.__upsellMoAttached = true;
    var mo = new MutationObserver(function(){ schedule(dialog); });
    mo.observe(dialog, { childList:true, subtree:true, attributes:true, attributeFilter:['class'] });
    dialog.addEventListener('transitionend', function(){ schedule(dialog); }, true);
  }
  attachDrawerObservers();
  // If drawer component mounts later:
  document.addEventListener('DOMContentLoaded', attachDrawerObservers);
  document.addEventListener('shopify:section:load', attachDrawerObservers);

  // bfcache
  window.addEventListener('pageshow', function(){ waitForSwiper(document); });
})();

/* Cart upsells sale price */
(function(){
  if (window.__upsellSaleStableV3) return;
  window.__upsellSaleStableV3 = true;

  function applyForRoot(root){
    var sale = (root.getAttribute('data-upsell-1-sale-price')||'').trim();
    if (!sale) return;

    var upsellHandle = (root.getAttribute('data-upsell-1-handle')||'').trim().toLowerCase();
    if (!upsellHandle) return;

    var slide = null;
    root.querySelectorAll('.fpro-ecupsells__slide').forEach(function(s){
      var h = (s.getAttribute('data-product-handle')||'').trim().toLowerCase();
      if (!slide && h === upsellHandle) slide = s;
    });
    if (!slide) return;

    var wrap = slide.querySelector('.fpro-ecupsells__price');
    if (!wrap) return;

    var current = wrap.querySelector('.fpro-price--current');
    var compare = wrap.querySelector('.fpro-ecupsells__compare');
    if (!current || !compare) return;

    var moneySpan = current.querySelector('.money');
    var saleHtml = moneySpan ? '<span class="money">'+sale+'</span>' : sale;

    if (!slide.getAttribute('data-upsell-original-html')) {
      slide.setAttribute('data-upsell-original-html', current.innerHTML);
    }
    var originalHtml = slide.getAttribute('data-upsell-original-html') || current.innerHTML;

    if (!compare.innerHTML.trim()) {
      var isStruck = /^\s*<\s*s[\s>]/i.test(originalHtml);
      compare.hidden = false;
      compare.innerHTML = isStruck ? originalHtml : '<s>'+originalHtml+'</s>';
    } else {
      compare.hidden = false;
    }

    if (current.innerHTML.trim() !== saleHtml) {
      current.innerHTML = saleHtml;
    }

    if (!wrap.__upsellPriceMO){
      var mo = new MutationObserver(function(){
        var now = current.innerHTML.trim();
        if (now !== saleHtml) current.innerHTML = saleHtml;
      });
      mo.observe(wrap, { childList:true, subtree:true, characterData:true });
      wrap.__upsellPriceMO = mo;
    }
  }

  function runAll(){
    document.querySelectorAll('[data-fpro-ecupsells]').forEach(applyForRoot);
  }

  function queueRuns(){
    runAll();
    setTimeout(runAll, 0);
    setTimeout(runAll, 80);
    setTimeout(runAll, 200);
  }

  document.addEventListener('DOMContentLoaded', queueRuns);
  ['shopify:section:load','cart:sections:replaced','cart:updated','line-item:removed','cart:cleared','cart-drawer:open']
    .forEach(function(evt){ document.addEventListener(evt, queueRuns); });
  window.addEventListener('pageshow', queueRuns);
  document.addEventListener('transitionend', function(e){
    if (e.target.closest && e.target.closest('cart-drawer-component')) queueRuns();
  }, true);

  document.addEventListener('submit', function(e){
    if (e.target && e.target.closest && e.target.closest('[data-fpro-ecupsells] .fpro-ecupsells__form')){
      queueRuns();
    }
  }, true);
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('[data-fpro-ecupsells] .fpro-ecupsells__atc');
    if (btn) queueRuns();
  }, true);
})();



document.addEventListener('click', function(event) {
    // Find the button or any element inside the button
    const button = event.target.closest('.dropdown-localization__button');
    if (!button) {
      // If clicking outside, close any open dropdowns
      document.querySelectorAll('dropdown-localization-component').forEach(comp => {
          comp.querySelector('[ref="panel"]')?.setAttribute('hidden', '');
          comp.querySelector('button')?.setAttribute('aria-expanded', 'false');
      });
      return;
    }

    const container = button.closest('dropdown-localization-component');
    const panel = container.querySelector('[ref="panel"]');
    
    if (panel) {
      const isHidden = panel.hasAttribute('hidden');
      if (isHidden) {
        panel.removeAttribute('hidden');
        button.setAttribute('aria-expanded', 'true');
      } else {
        panel.setAttribute('hidden', '');
        button.setAttribute('aria-expanded', 'false');
      }
    }
  });